function appendParams(path: string, params: { SalesOrder?: number }): string {
  if (params && params.SalesOrder) {
    const search = new URLSearchParams();
    if (params.SalesOrder) {
      search.append('SalesOrder', params.SalesOrder.toString());
    }
    path += `?${search.toString()}`;
  }

  return path;
}

export default [
  {
    id: '1',
    label: 'Sales Order Enquiry in new tab',
    action: (params: { SalesOrder?: number}) => { window.open(appendParams('/sales-order-enquiry/order-details', params)); }
  },
  {
    id: '2',
    label: 'Sales Order Enquiry',
    action: (params: { SalesOrder?: number}) => { window.location.assign(appendParams('/sales-order-enquiry/order-details', params)); }
  }
];
